import { NgModule, ModuleWithProviders } from '@angular/core';
import { GoogleCalendarAPIComponent } from './google-calendar-api.component';
import { config } from '../data.model';
import { GoogleCalendarAPIService } from './google-calendar-api.service';

@NgModule({
  declarations: [GoogleCalendarAPIComponent],
  imports: [
  ],
  exports: [GoogleCalendarAPIComponent],
})
export class GoogleCalendarAPIModule {
  /**
  * A static method to provide configuration to the AddToGoogleCalanderModule.
  * @param config Use the AddToGoogleCalanderModule to provide configuration
  * information to the module.
  */
  static forRoot(config: config): ModuleWithProviders {
    return {
      ngModule: GoogleCalendarAPIModule,
      providers: [GoogleCalendarAPIService, { provide: 'config', useValue: config }]
    };
  }
}
